import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import BazaarVoice from '../../components/BazaarVoice/BazaarVoice'
import { loadReviewsRequest } from '../../actions/reviewsAppActions'
import { isReviewsArgosCard } from '../../helpers/pathCheck'

import BazaarGlobalStyle from './ReviewsContainer.styles.js'

export const ReviewsContainer = ({ location, loadReviews }) => {
  const bvData = useRef(null)

  useEffect(() => {
    if (isReviewsArgosCard(location.pathname)) {
      loadReviews(true)
      const isDevelopment = !(process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging')
      const script = document.createElement('script')
      script.src = `//apps.bazaarvoice.com/deployments/argos-afs/main_site/${
        isDevelopment ? 'staging' : 'production'
      }/en_GB/bv.js`
      script.async = true
      document.body.appendChild(script)

      const waitForBvContent = () => {
        const bvContentLength = bvData.current.childNodes.length
        if (bvContentLength === 0) setTimeout(waitForBvContent, 2500)
        else loadReviews(false)
      }
      waitForBvContent()
    }
  }, [])

  const errorMsg = 'Sorry we are having trouble loading this page, please try again or check back later.'
  return (
    <>
      <BazaarGlobalStyle />
      <div className='reviews-container'>
        <ErrorBoundary showErrorMsg errorMsg={errorMsg}>
          {isReviewsArgosCard(location.pathname) ? (
            <div ref={bvData} data-bv-show='reviews' data-bv-product-id='argos-card' />
          ) : (
            <BazaarVoice />
          )}
        </ErrorBoundary>
      </div>
    </>
  )
}

ReviewsContainer.propTypes = {
  isLoading: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
}

ReviewsContainer.defaultProps = {
  isLoading: false,
}
const mapStateToProps = (state) => ({
  isLoading: state.homepageApp.isLoading,
})

const mapDispatchToProps = (dispatch) => ({
  loadReviews: (isLoading) => dispatch(loadReviewsRequest(isLoading)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewsContainer)
